module.exports = __webpack_public_path__ + "static/media/infoJumbo2.0473c94a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/exeron/images/infoJumbo2.jpg
// module id = 504
// module chunks = 0